import { render } from "./EditRayon.vue?vue&type=template&id=3da58b83&ts=true"
import script from "./EditRayon.vue?vue&type=script&lang=ts"
export * from "./EditRayon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__